import React, { Component, createRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Navigation from "../screens/Navigation.jsx";
import Headroom from "react-headroom";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios"
import { Modal, Row } from "react-bootstrap";
import Markdownkatexnew from "./Markdown.js";
import Select, { components } from 'react-select';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';

import Socket from "../screens/Chat.jsx";
import { isAuth, removeLocalStorage } from "../helpers/auth.js";
import { FaDownload, FaExpandAlt, FaExpandArrowsAlt } from "react-icons/fa";
import { parseISO } from "date-fns";
import TimeAgo from 'timeago-react';
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';
import { MdCheck, MdCheckCircle, MdDelete, MdDeleteOutline, MdDescription, MdRemove, MdRemoveCircle, MdRemoveCircleOutline } from "react-icons/md";
timeago.register('es', es);


const options = [
	{ value: 'direccion', label: 'Direccion' },
	{ value: 'academico', label: 'Académico' },
	{ value: 'administracion', label: 'Administración' },
	{ value: 'subdireccion', label: 'Sub dirección' },
	{ value: 'jefeeducacion', label: 'Jefe de educacion' },
	{ value: 'jefeartista', label: 'Jefe de artista profesional' }
];


export default class CreateNote extends Component {
	state = {
		showModal: false, title: "", detail: "", option: '', dependence: "direccion", name: '', size: '', type: '', file: "", i: '', ip: '', j: '', noww: '', remiter: '', id: "", dni: "", tramites: "",
		submit: "Crear",
		resumen: "",
		tittle: "",
		savedtramite: [],
		editing: false
	};

	// {
	// 		"dni": "76987341",
	// 		"nombres": "VIRMA CHARMELY",
	// 		"apellidoMaterno": "ARAUJO",
	// 		"apellidoPaterno": "FLORES",
	// 	}
	open = () => this.setState({ showModal: true });
	close = () => this.setState({ showModal: false });

	async componentWillUnmount() {
		removeLocalStorage("tramite");

	}

	async componentDidMount() {
		fetch('https://ipapi.co/json/')
			.then((res) => res.json())
			.then((data) => {
				console.log(data, "wwwwwwww")
				this.setState({
					ip: data,
				});
			})
			.catch((err) => console.error("Error fetching IP location:", err))
		if (isAuth().rol === '1') { await this.getTramites() }

		const fechaActual = new Date();
		const formatoIso = fechaActual.toISOString();
		this.setState({
			noww: formatoIso,
		});

		this.getstorages()

	}

	getstorages = async () => {
		const wwwww = localStorage.getItem('tramite');
		this.setState({ savedtramite: JSON.parse(wwwww) })
		console.log(this.state.savedtramite);

	}

	getTramites = async () => {

		await axios.get(`${process.env.REACT_APP_API_URL}/tramites`)
			.then((res) => {
				console.log(res.data, "www")
				this.setState({ tramites: res.data })
				// this.setState({ editing: false })
			})
			.catch((err) => {
				toast.error(err);
			})
	};


	getRemiter = async () => {
		if (this.state.dni.length > 5) {
			this.setState({ editing: true })
			await axios.post(`${process.env.REACT_APP_API_URL}/users/userDni`, { dni: this.state.dni })
				.then((res) => {
					console.log(res.data.data, "www")
					this.setState({ remiter: res.data.data })
					this.setState({ editing: false })
				})
				.catch((err) => {
					toast.error(err);
				})
		} else {
			toast.warning('Escriba su dni')
		}
	};

	getRemiterdata = async () => {
		if (this.state.dni.length > 5) {
			this.setState({ editing: true })
			await axios.get(`${process.env.REACT_APP_API_URL}/tramites/${this.state.dni}`)
				.then((res) => {
					console.log(res.data, "www")
					this.setState({ tramites: res.data })
					this.setState({ editing: false })
					removeLocalStorage("tramite");
					this.getstorages()
				})
				.catch((err) => {
					toast.error(err);
				})
		} else {
			toast.warning('Escriba su dni')
		}
	};

	getReduce = async () => {
		this.setState({ editing: true })

		await axios.post(`${process.env.REACT_APP_API_URL}/users/userReduce`, { dni: this.state.dni })
			.then((res) => {
				console.log(res.data.data, "www")
				this.setState({ remiter: res.data.data })
				this.setState({ editing: false })
			})
			.catch((err) => {
				toast.error(err);
			})
	};

	sendSurvey = async () => {

		if (this.state.title && this.state.detail) {
			this.setState({ editing: true })
			const data = new FormData()
			data.append("title", this.state.title)
			data.append("dependence", this.state.dependence)
			data.append("proveido", [])
			data.append("archivo", this.state.file)
			data.append("size", this.state.size)
			data.append("type", this.state.type)
			data.append("dni", this.state.remiter.dni)
			data.append("nombres", this.state.remiter.nombres)
			data.append("apellidomaterno", this.state.remiter.apellidoMaterno)
			data.append("apellidopaterno", this.state.remiter.apellidoPaterno)
			data.append("asunto", this.state.title)
			data.append("detail", this.state.detail)
			console.log(data)

			await axios.post(`${process.env.REACT_APP_API_URL}/tramites/`, data)
				.then((www) => {
					// this.getTramites()
					console.log(www.data.saved)
					this.setState({ remiter: "", title: "", detail: "", option: '', dependence: "direccion", name: '', size: '', type: '', file: "", editing: false, id: "", dni: "", tramites: "" })

					let myArray = JSON.parse(localStorage.getItem('tramite')) || [];
					let newItem = www.data.saved;
					myArray.push(newItem);
					localStorage.setItem('tramite', JSON.stringify(myArray));
					this.getstorages()
				})
				.catch((err) => {
					toast.error(err);
				})
		} else {
			toast.info('Rellene todos los campos')
		}
	};


	onInputChange = e => {
		console.log(e.target.name, e.target.value)
		this.setState({
			[e.target.name]: e.target.value,
		});
	};

	fileSelectHandler = (file) => {
		console.log(file);
		this.setState({
			file: file[0],
			name: file[0].name,
			size: file[0].size,
			type: file[0].type,
		})
		const array = ['application/pdf', 'pdf', 'jpg']
		if (file[0].size < 105048576 && array.includes(file[0].type)) {
			console.log(file[0])
			const reader = new FileReader();
			// reader.onload = e => setFormData({ ...formData, photoSelected: reader.result, files: file, namefile: file[0].type });
			reader.readAsDataURL(file[0]);
		} else {
			toast.dark(
				"Solo se acepta archivos no mayor a 1MB en formatos pdf, jpeg, jpg y png "
			);
		}
	}

	deleteSurvey = async (id, i) => {
		const response = window.confirm("Deseas eliminar este item?");
		if (response) {
			await axios.delete(`${process.env.REACT_APP_API_URL}/tramites/${id}`)
				.then((res) => {
					// console.log(res.data.data, "www")
					if (isAuth().rol === '1') { this.getTramites() }

				})
				.catch((err) => {
					toast.error(err);
				})

			let myData = JSON.parse(localStorage.getItem('tramite'));
			if (myData) {
				myData.splice(i, 1);
				localStorage.setItem('tramite', JSON.stringify(myData))
				this.getstorages()
			}

		}
	}


	handleChange = (e) => {
		console.log(e.value)
		this.setState({
			dependence: e.value,
		})
	};

	fileInputRef = createRef();
	fileInput = () => {
		if (this.fileInputRef.current) {
			this.fileInputRef.current.click();
			// this.inputRef.current.focus();
		}
	};

	addHoursToLocalTime = (date, hoursToAdd) => {
		const originalDate = new Date(date);
		originalDate.setHours(originalDate.getHours() + hoursToAdd);
		return originalDate.toISOString();
	};
	// const wwwww = new Date();
	// timestop = addHoursToLocalTime(this.state.timetest); // Example: Adding 3 hours to the current local 

	render() {
		const { dependence } = this.state;

		return (
			<>
				<ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
				<Headroom>
					<Navigation />
				</Headroom>

				{/* <Modal show={this.state.showModal} onHide={() => { this.close(); }} animation={false}>
					<div className="modal-header font-weight-bold h5"> {this.state.submit} </div>
					<div className="modal-body">
						<div className="mb-3">
							<label htmlFor="www" className="form-label">Título</label>
							<input type="text" id="www" className="form-control my-1" placeholder="Título" onChange={this.onInputChange} name="title" value={this.state.title} />
						</div>

						<div className="mb-3">
							<label htmlFor="wwwww" className="form-label">Detalle (Escriba texto en formato Markdown [<a href="https://www.markdownguide.org/basic-syntax/" target="_blank">Tutorial!</a>])</label>
							<textarea type="text" id="wwwww" className="form-control scroll" placeholder="Contenido" rows="9" name="detail" onChange={this.onInputChange} value={this.state.detail} required ></textarea>
							<Markdownkatexnew>
								{this.state.detail}
							</Markdownkatexnew>
						</div>
					</div>
					<div className="modal-footer d-flex right-content-center">
						{this.state.option === '1' ? <button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.CreateTheme() }}> CrearTheme </button> : ""}
						<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.close() }}> Close </button>
					</div>
				</Modal >
 */}

				<div className="container" style={{ padding: '.6em' }}>

					{isAuth().rol === '1' ?
						<button className="btn btn-primary my-3 form-control" onClick={this.getReduce} disabled={this.state.editing}>
							Reducir Tamaño de archivo
						</button> : ''}
					<br />


					<div id="accordion">

						<div className="btn-group text-center w-100" style={{ marginBottom: '1.5em' }}>
							<button className="btn btn-primary collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
								Enviar trámite
							</button>
							<button className="btn btn-warning" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
								Mis trámites
							</button>
						</div>

						<div id="collapseOne" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
							<div className="input-group my-1">
								<input type="text" id="www" className="form-control border border-warning" placeholder="DNI" disabled={this.state.editing} name="dni" onChange={this.onInputChange} value={this.state.dni} />
								<button className="btn btn-warning form-control" onClick={this.getRemiterdata} disabled={this.state.editing}>
									Buscar trámites
								</button>
							</div>
						</div>

						<div id="collapseTwo" className="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
							<div className="input-group">
								<input type="text" id="www" className="form-control border border-primary" placeholder="DNI" disabled={this.state.editing} name="dni" onChange={this.onInputChange} value={this.state.dni} />
								<button className="btn btn-primary form-control" onClick={this.getRemiter} disabled={this.state.editing}>
									Verificar datos
								</button>
							</div>

						</div>

					</div>


					<div style={{ display: this.state.remiter ? '' : 'none' }}>
						{/* {this.state.remiter != '' ? */}
						<div className="row justify-content-center align-items-center" style={{ padding: '.8em' }}>
							<div className="col-md-3 text-center" style={{ padding: '.1em' }}>
								<label htmlFor="www" className="form-label">DNI: {this.state.remiter.dni}</label>
							</div>
							<div className="col-md-3 text-center" style={{ padding: '.1em' }}>
								<label htmlFor="www" className="form-label">Nombres: {this.state.remiter.nombres}</label>
							</div>
							<div className="col-md-3 text-center" style={{ padding: '.1em' }}>
								<label htmlFor="www" className="form-label">Apellido paterno: {this.state.remiter.apellidoPaterno}</label>
							</div>
							<div className="col-md-3 text-center" style={{ padding: '.1em' }}>
								<label htmlFor="www" className="form-label">Apellido materno: {this.state.remiter.apellidoMaterno}</label>
							</div>
							<input type="file" className="form-control d-none" onChange={(e) => { this.fileSelectHandler(e.target.files); }} ref={this.fileInputRef}>
							</input>
						</div>
						{/* : ''} */}

						<div className="mb-3">
							<div>
								<label htmlFor="wwwww" className="form-label mt-3">Dependencia a enviar</label>
								<Select className="" defaultValue={options.filter(({ value }) => value === this.state.dependence)} onChange={this.handleChange} options={options} placeholder="Seleccione dependencia" />
							</div>
							<label htmlFor="wwwww" className="form-label mt-3">Asunto</label>
							<input type="text" id="www" className="form-control" placeholder="Asunto" name="title" onChange={this.onInputChange} value={this.state.title} />

							<label htmlFor="wwwww" className="form-label mt-3">Detalles</label>
							<CKEditor className="form-control" editor={ClassicEditor} config={{
								language: 'es', placeholder: "Descripción de tramite",
								toolbar: ["undo", "redo", "|", "math", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"]
							}} data={this.state.detail} onChange={(event, editor) => {
								this.setState({ detail: editor.getData() })
								//wwWw(editor.getData())
							}} onReady={editor => {
								// console.log('Editor is ready to use!', editor)
							}}
								name="detail"
							/>
						</div>


						<button className="btn btn-warning w-100" onClick={this.fileInput}>Cargar archivo</button>
						<br />
						<div className=" text-center w-100 text-success" style={{ display: this.state.file ? '' : 'none' }}>
							Nombre : {this.state.name} Tamaño: {this.state.size} Tipo: {this.state.type}
							<br />
							<button className="btn btn-success text-center w-100" onClick={() => { this.sendSurvey() }} disabled={this.state.editing}>
								Enviar tramite
							</button>

						</div>

					</div>


					<div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
						{
							this.state.savedtramite && this.state.savedtramite.length >= 1 ? this.state.savedtramite.map((number, i) =>
								<div key={i + 1} className="col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1">
									<div className="p-1 bg-light rounded">
										<div className="h5">
											{number.title}
										</div>
										<div className="">
											{number.dni} {number.nombres} {number.apellidopaterno} {number.apellidomaterno}
										</div>
										{/* <Markdownkatexnew>
											{number.detail}
										</Markdownkatexnew> */}
										{number.size ? (number.size / (1024 * 1024)).toFixed(3) + " MB" : ''} {number.type ? `(${number.type})` : ''}

										{number.file ? <a className="btn" target="_blank" href={`${process.env.REACT_APP_URL}/tramite/${number.file}`} >
											<FaDownload style={{ color: '#92bee0ff', fontSize: '34px' }} />
										</a> : ''}
										<button className="btn" onClick={() => { this.open(); this.setState({ resumen: number.detail, tittle: number.title }) }}>
											<FaExpandAlt style={{ color: '#b88026ff', fontSize: '34px' }} />
										</button>

									</div>
									<button className="btn btn-info text-center w-100" onClick={() => { this.deleteSurvey(number._id, i) }} >
										Borrar tramite
									</button>
								</div>
							) : ''}
					</div>

					{/* < Socket /> */}
					<div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
						{
							this.state.tramites ? this.state.tramites.map((number, i) =>
								<div key={i + 1} className="col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1">
									<div>
										<div className="p-1 bg-light rounded">
											<div className="h5">
												{number.title}
											</div>
											<div className="">
												{number.dni} {number.nombres} {number.apellidopaterno} {number.apellidomaterno}. Creado	<TimeAgo datetime={number.createdAt} locale='es' />
											</div>
											{/* <Markdownkatexnew>
												{number.detail}
											</Markdownkatexnew> */}
											{number.size ? (number.size / (1024 * 1024)).toFixed(3) + " MB" : ''} {number.type ? `(${number.type})` : ''}

											<div className="btn-group text-center w-100">
												{number.file ? <a className="btn" target="_blank" href={`${process.env.REACT_APP_URL}/tramite/${number.file}`} >
													<FaDownload style={{ color: '#92bee0ff', fontSize: '34px' }} />
												</a> : ''}
												<button className="btn" onClick={() => { this.open(); this.setState({ resumen: number.detail, tittle: number.title }) }}>
													<FaExpandArrowsAlt style={{ color: '#692ea0ff', fontSize: '34px' }} />
												</button>
												<button className="btn" onClick={() => { this.open(); this.setState({ resumen: number.detail, tittle: number.title }) }}>
													<MdCheck style={{ color: '#692ea0ff', fontSize: '34px' }} />
												</button>
												<button className="btn" onClick={() => { this.deleteSurvey(number._id) }} style={{ display: this.state.noww < this.addHoursToLocalTime(number.createdAt, 1) || isAuth().rol === '1' ? '' : 'none' }}>
													<MdRemoveCircleOutline style={{ color: '#a02e3dff', fontSize: '34px' }} />
												</button>
											</div>
										</div>
									</div>
								</div>
							) : ''}
					</div>

					<Modal size="lg" show={this.state.showModal} onHide={() => { this.close(); }} animation={false}>
						<Modal.Header>
							<div className="h5">
								{this.state.tittle}
							</div>
						</Modal.Header>
						<Modal.Body>
							<Markdownkatexnew>
								{this.state.resumen}
							</Markdownkatexnew>
						</Modal.Body>
						<Modal.Footer>
							<button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => { this.close() }}>
								Cerrar
							</button>
						</Modal.Footer>
					</Modal>

					{/* <button className="btn btn-outline-success w-100 ffont" onClick={() => { this.open(); this.setState({ select: "clase", type: "general", files: [], title: "note.title" }) }}>
            Encuesta'S<br />
            <MdOutlineSupervisedUserCircle style={{ fontSize: '54px' }} />
          </button> */}

				</div>
			</>
		);
	}
}
